/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export var HIERARCHY = Object.freeze({
  primary: 'primary',
  secondary: 'secondary'
});
export var SHAPE = Object.freeze({
  pill: 'pill',
  rectangle: 'rectangle'
});
export var COLOR = Object.freeze({
  accent: 'accent',
  primary: 'primary',
  positive: 'positive',
  negative: 'negative',
  warning: 'warning'
});
export var PLACEMENT = Object.freeze({
  topLeft: 'topLeft',
  topRight: 'topRight',
  bottomRight: 'bottomRight',
  bottomLeft: 'bottomLeft',
  topLeftEdge: 'topLeftEdge',
  topEdge: 'topEdge',
  topRightEdge: 'topRightEdge',
  bottomRightEdge: 'bottomRightEdge',
  bottomEdge: 'bottomEdge',
  bottomLeftEdge: 'bottomLeftEdge',
  leftTopEdge: 'leftTopEdge',
  rightTopEdge: 'rightTopEdge',
  rightBottomEdge: 'rightBottomEdge',
  leftBottomEdge: 'leftBottomEdge'
});
export var ROLE = Object.freeze({
  badge: 'badge',
  notificationCircle: 'notificationCircle',
  hintDot: 'hintDot'
});